import { t } from "@lingui/core/macro";
import { LimeSelect } from "@/Components/NextBase/LimeSelect";

type SelectPermissionOption = {
  value: string;
  label: string;
};

type SelectPermissionProps = {
  permission: {
    id: string;
    label: string;
    description?: string;
    options: SelectPermissionOption[];
  };
  value?: string;
  onChange: (value: string) => void;
  disabled?: boolean;
};

export const SelectPermission = ({
  permission,
  value,
  onChange,
  disabled,
}: SelectPermissionProps) => {
  return (
    <div className="mb-0 flex w-full flex-1 justify-between p-0 md:mb-2.5 md:px-5 md:py-2.5">
      <div className="flex flex-1 flex-col gap-2.5">
        <span
          className="font-semibold leading-tight"
          style={{ lineHeight: "1.3rem" }}
        >
          {permission.label}
        </span>
        {permission.description && (
          <span className="leading-tight" style={{ lineHeight: "1.3rem" }}>
            {permission.description}
          </span>
        )}
      </div>
      <div className="ml-4 self-center">
        <LimeSelect
          value={value}
          onChange={onChange}
          items={permission.options.map((option) => ({
            key: option.value,
            label: option.label,
          }))}
          isDisabled={disabled}
          placeholder={t`Izberi možnost`}
          aria-label={permission.label}
          className="min-w-[200px]"
        />
      </div>
    </div>
  );
};
